import React, { Component } from "react";
import { Helmet } from "react-helmet";
import logo from "../../assets/logo.png";
import Navbar from "../Navbar/Navbar";
import InterestRateContent from "./InterestRateContent";
import BottomBar from "../BottomBar/BottomBar";
class InterestRate extends Component {
  render() {
    return (
   
        <div id='terms' className="main">
          <Helmet>
            <title>Interest Rate | MoneyMonk</title>
            <meta name="description" content="View the applicable interest rates on MoneyMonk personal loans and understand how your EMI is calculated." />
            <link rel="canonical" href="https://moneymonkapp.in/interestrate" />
          </Helmet>
          <Navbar imageData={logo} />
          <InterestRateContent />
          <BottomBar />
        </div>

    );
  }
}

export default InterestRate;
